import React, { ReactElement } from 'react';
import { UploadedFile } from 'slovlex-idsk-react-components';
import { useClientStatusContext } from '../../../context/ClientStatusContext';
import PredpisEurlexPriloha from '../../../model/PredpisEurlexPriloha';
import { downloadPrilohaByUuid } from '../../../client/downloadPrilohaClient';
import Uuid from '../../../model/Uuid';

interface Props {
  priloha: PredpisEurlexPriloha;
}

const PredpisEurlexPrilohaComponent = ({ priloha }: Props): ReactElement => {
  const { handleStatus } = useClientStatusContext();

  const handleClick = async (uuid: Uuid): Promise<void> => {
    try {
      const { data } = await downloadPrilohaByUuid(uuid);

      if (data) {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${priloha.fileName}`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (exception) {
      if (exception.response.status === 404) {
        const clientStatus = {
          loading: false,
          finished: true,
          responseCode: 404,
          failed: true,
          generalErrors: [
            { message: 'Pri sťahovaní dokumentu nastal neočakávaný problém (neexistujúci súbor).' }],
          fieldErrors: [],
        };
        handleStatus(clientStatus);
      }
    }
  };

  return (
    <UploadedFile
      file={new File([''], `${priloha.fileName}`)}
      fileSize={priloha.fileSize}
      onDownload={() => handleClick(priloha.uuid)}
      inputFilename={priloha.fileName}
    />
  );
};

export default PredpisEurlexPrilohaComponent;
